export default (i18n, toastr) => {
  return (res) => {
    if (!res?.config) return;

    const { config, data } = res;

    if (config.method === 'delete' && config.url.includes('/addon-subscription')) {
      toastr.s('You successfully canceled your add-on subscription');
    }

    return res;
  };
};
